// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

headerStyles.titleGridItem = {
    width: [10, 9, 7, 5, 6],
};

headerStyles.buttonsGridItem = {
    ...headerStyles.buttonsGridItem,
    width: [2, 3, 5, 7, 6],
};

headerStyles.titleText = {
    variant: "h1",
    as: "h1",
    css: css`
        ${xScreen("lte", "sm")} {
            margin-bottom: 8px;
        }
    `,
};

headerStyles.costCodesButton = {
    variant: "secondary",
    css: css`
        display: inline-block;
        margin-right: 16px;
    `,
};

headerStyles.assignBudgetsButton = {
    variant: "secondary",
    css: css`
        display: inline-block;
        margin-right: 6px;
    `,
};
